export const oppCustomFieldConstants = {
  OPP_CUSTOM_FIELD_CREATE_LOADING: 'OPP_CUSTOM_FIELD_CREATE_LOADING',
  OPP_CUSTOM_FIELD_CREATE_SUCCESS: 'OPP_CUSTOM_FIELD_CREATE_SUCCESS',
  OPP_CUSTOM_FIELD_CREATE_FAILURE: 'OPP_CUSTOM_FIELD_CREATE_FAILURE',

  OPP_CUSTOM_FIELD_LIST_LOADING: 'OPP_CUSTOM_FIELD_LIST_LOADING',
  OPP_CUSTOM_FIELD_LIST_SUCCESS: 'OPP_CUSTOM_FIELD_LIST_SUCCESS',
  OPP_CUSTOM_FIELD_LIST_FAILURE: 'OPP_CUSTOM_FIELD_LIST_FAILURE',

  OPP_CUSTOM_FIELD_EDIT_LOADING: 'OPP_CUSTOM_FIELD_EDIT_LOADING',
  OPP_CUSTOM_FIELD_EDIT_SUCCESS: 'OPP_CUSTOM_FIELD_EDIT_SUCCESS',
  OPP_CUSTOM_FIELD_EDIT_FAILURE: 'OPP_CUSTOM_FIELD_EDIT_FAILURE',

  OPP_CUSTOM_FIELD_DELETE_LOADING: 'OPP_CUSTOM_FIELD_DELETE_LOADING',
  OPP_CUSTOM_FIELD_DELETE_SUCCESS: 'OPP_CUSTOM_FIELD_DELETE_SUCCESS',
  OPP_CUSTOM_FIELD_DELETE_FAILURE: 'OPP_CUSTOM_FIELD_DELETE_FAILURE',

  OPP_CUSTOM_FIELD_ERROR_RELOAD: 'OPP_CUSTOM_FIELD_ERROR_RELOAD'
};
